import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../_services/_nav.service';
import moment from 'moment';
import 'moment/locale/es';
import {forkJoin} from 'rxjs';
import {Modalidad} from '../../_models/modalidad';
import {ListaService} from '../../_services/lista.service';
import {ListaItem} from '../../_models/lista-item';
import {ModalidadAutorizacionService} from '../../_services/modalidad-autorizacion.service';
import {ModalidadAutorizacion} from '../../_models/modalidad-autorizacion';

@Component({
  selector: 'app-modalidades-autorizaciones',
  templateUrl: 'modalidades-autorizaciones.component.html'
})

export class ModalidadesAutorizacionesComponent implements OnInit {

  @Input() modalidad: Modalidad;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  modalidadAutorizacion: ModalidadAutorizacion;
  lisAutorizaciones: SelectItem[] = [];
  lisModalidadesAutorizaciones: ModalidadAutorizacion [] = [];
  lisTodasModalidadesAutorizaciones: ModalidadAutorizacion [] = [];
  autorizaciones: any [] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];

  constructor(private modAutServicio: ModalidadAutorizacionService,
              private conServicio: ConfirmationService,
              private lisServicio: ListaService,
              private nav: NavService,
              private confirmationService: ConfirmationService,
              private fb: FormBuilder) {

  }

  ngOnInit(): void {
    // Definiendo columnas datatable
    this.columnas = [
      {field: 'nombreDocumento', header: this.nav.buscarMensaje('MODALIDADES.LBL_NOMBREDOCUMENTO'), sort: true},
      {field: 'acciones', header: this.nav.buscarMensaje('LBL_ACCIONES'), sort: true},
    ];
    // Inicializando formulario
    this.inicializarFormulario();
    // Inicializando las listas
    this.inicializarListas();
  }

  llenarAutorizaciones() {
    this.autorizaciones = [];
    for (let aut of this.lisAutorizaciones) {
      for (let modAut of this.lisModalidadesAutorizaciones) {
        if (aut.value === modAut.idAutorizacion) {
          this.autorizaciones.push(aut);
        }
      }
    }
  }

  inicializarListas() {
    this.lisAutorizaciones = [];
    this.lisModalidadesAutorizaciones = [];
    this.carInformacionInicial = true;
    forkJoin(
      this.lisServicio.getMasterDetails('ListasAutorizaciones'),
      this.modAutServicio.listadoModalidadesAutorizacionesHabilitadasIdModalidad(this.modalidad.idModalidad),
      this.modAutServicio.listadoModalidadesAutorizacionesIdModalidad(this.modalidad.idModalidad)
    ).subscribe(([autorizaciones, modalidadesAutorizaciones, todasModalidadesAutorizaciones]) => {
        autorizaciones.map((s: ListaItem) => {
          this.lisAutorizaciones.push({label: s.nombre, value: s.idLista});
        });
        this.lisModalidadesAutorizaciones = modalidadesAutorizaciones;
        this.lisTodasModalidadesAutorizaciones = todasModalidadesAutorizaciones;
        this.llenarAutorizaciones();
        this.descartarAutorizacionesAgregadas();
        this.carInformacionInicial = false;
      }
    );
  }

  inicializarFormulario() {
    this.formulario = this.fb.group({
      idAutorizacion: [null, [Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.crearModalidadAutorizacion();
    }
  }

  descartarAutorizacionesAgregadas() {
    let nuevaLisAutorizaciones: SelectItem[] = [];
    for (let aut of this.lisAutorizaciones) {
      let autorizacionExistente: boolean = false;
      for (let modAut of this.lisModalidadesAutorizaciones) {
        if (aut.value === modAut.idAutorizacion) {
          autorizacionExistente = true;
        }
      }
      if (autorizacionExistente === false) {
        nuevaLisAutorizaciones.push(aut);
      }
    }
    this.lisAutorizaciones = nuevaLisAutorizaciones;
  }

  crearModalidadAutorizacion() {
    this.guardando = true;
    const modalidadAutorizacionExistente = this.lisTodasModalidadesAutorizaciones.find(x => x.idAutorizacion === this.formulario.value.idAutorizacion);
    if (modalidadAutorizacionExistente === undefined) {
      this.modalidadAutorizacion = {} as ModalidadAutorizacion;
      this.modalidadAutorizacion.indicadorHabilitado = true;
      this.modalidadAutorizacion.idAutorizacion = this.formulario.value.idAutorizacion;
      this.modalidadAutorizacion.idModalidad = this.modalidad.idModalidad;
      this.modAutServicio.crear(this.modalidadAutorizacion).subscribe(
        res => {
          this.nav.setMesage(1);
          this.guardando = false;
          this.submitted = false;
          this.formulario.reset();
          this.inicializarListas();
        },
        error => {
          this.nav.setMesage(3);
          this.guardando = false;
          this.submitted = false;
          this.formulario.reset();
        });
    } else {
      this.modAutServicio.obtenerPorId(modalidadAutorizacionExistente.idModalidadAutorizacion).subscribe(
        res => {
          let modAuto = res;
          modAuto.indicadorHabilitado = true;
          this.modAutServicio.actualizar(modAuto).subscribe(
              result => {
                this.nav.setMesage(1);
                this.guardando = false;
                this.submitted = false;
                this.formulario.reset();
                this.inicializarListas();
              },
            error1 => {
              this.nav.setMesage(3);
              this.guardando = false;
              this.submitted = false;
              this.formulario.reset();
            }
          );
        }, error => {
          this.guardando = false;
          this.submitted = false;
          this.formulario.reset();
        }
      );
    }
  }
  // Funcion para eliminar una autorizacion (documento) de la modalidad
  eliminarModalidadAutorizacion(id: string) {
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar este registro?',
      header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.guardando = true;
        // Se busca la autorizacion (documento)
        let aut = this.lisModalidadesAutorizaciones.find(x => x.idAutorizacion === id);
        if (aut !== undefined) {
          // Se inhabilita y se guarda
          aut.indicadorHabilitado = false;
          this.modAutServicio.actualizar(aut).subscribe(
            result => {
              this.guardando = false;
              this.submitted = false;
              this.formulario.reset();
              this.nav.setMesage(2);
              this.inicializarListas();
            },
            error => {
              this.guardando = false;
              this.submitted = false;
              this.formulario.reset();
              this.nav.setMesage(3);
            }
          );
        }
      },
      reject: () => {
      }
    });
  }

  get f() {
    return this.formulario.controls;
  }

}
